export default __webpack_public_path__ + "static/media/Frame.7792faf1.svg";